import 'leaflet'
import PopupCreator from "./PopupCreator";
import MarkerCreator from "./MarkerCreator";

class BaseDrawer {

  _markers = {}
  _circles = {}

  constructor (map, vm, opts = {}) {
    this._map = map
    this.vm = vm
    this.popupCreator = new PopupCreator(vm)
    this.markerCreator = new MarkerCreator(vm)
    this.$emitter = vm.$emitter
  }

  drawMarkers (markersModel = [], opts = {}) {
    markersModel.forEach(m => {
      this.drawMarker(m, opts)
    })
  }

  dropVueWatchers (data) {
    return JSON.parse(JSON.stringify(data))
  }

  /**
   * Compaer two coords
   * @param coordFirst
   * @param coordNext
   * @param precision
   * @returns {boolean}
   */
  isNearWear (coordFirst = {}, coordNext = {}, precision = 3) {
    if (coordFirst && coordNext && coordFirst.lat && coordNext.lat) {
      const lat = (+coordFirst.lat).toFixed(precision) === (+coordNext.lat).toFixed(precision)
      const lng = (+coordFirst.lng).toFixed(precision) === (+coordNext.lng).toFixed(precision)
      return lat && lng
    }
    return false
  }

  getMarketId (obj) {
    return `${obj.id}${obj.type || ''}`
  }

  drawMarker (markerModel = {}, opts = {}) {
    let id = this.getMarketId(markerModel)
    if (!this._markers[id]) {
      this._markers[id] = this.markerCreator.getMarker(markerModel, 'default', markerModel.id)
    }
    return this.drawIfNotExist(this._markers[id], opts)
  }

  drawCircle (markerModel, radius = 10) {
    const id = this.getMarketId(markerModel)
    if (!this._circles[id]) {
      this._circles[id] = this.markerCreator.circle(markerModel, radius)
    }
    this._circles[id].addTo(this._map)
  }

  removeCircle(markerModel) {
    let id = this.getMarketId(markerModel)
    if (this._circles[id]) {
      this._map.removeLayer(this._circles[id])
      delete this._circles[id]
    }
  }

  removeMarker(markerModel) {
    let id = this.getMarketId(markerModel)
    if (this._markers[id]) {
      this._map.removeLayer(this._markers[id])
      delete this._markers[id]
    }
  }

  onMarkerClick (e, marker) {
    this.createPopup(marker)
  }

  drawIfNotExist (marker, opts = {}) {
    if (!marker._map) {
      if (opts.attachToLayer) {
        marker.addTo(opts.attachToLayer)
      } else {
        marker.addTo(this._map)
      }
      marker.on('click', (e) => {
        this.onMarkerClick(e, marker)
      })
    }

    if (marker.options.openedPopupInfo === this.vm.$route.query.openedPopupInfo) {
      this.onMarkerClick({}, marker)
    }

    return marker
  }

  registerOpenPopup (popup) {
    this.vm.registerOpenPopup(popup)
  }

  createPopup (marker, options = {}) {
    let {forceReDraw} = options
    // fix: opened relation edit form
    if (forceReDraw && marker._popup) {
      marker._popup.remove()
      marker._popup = null
    }
    let popup = null
    let popupOptions = options;
    if(marker && marker.options && marker.options.popupOptions) {
      popupOptions = marker.options.popupOptions;
    }
    if (!marker._popup) {
      let popupId = this.getMarketId(marker.options.model)
      popup = this.popupCreator.getPopup(marker, marker.options.model.type, popupId, popupOptions)
      if (popup) {
        marker.bindPopup(popup).openPopup()
        this.registerOpenPopup(popup)
      }
    } else {
      this.registerOpenPopup(marker._popup)
      popup = marker._popup
    }

    if (!popupOptions.autoPan) {
      this.punPopup(marker, popup)
    }
    return popup
  }

  /**
   * if popup bounds leave container bound
   * set new map center
   * @param marker
   * @param popup
   */
  punPopup (marker, popup) {
    setTimeout(() => {
      if (marker && marker._map && popup) {
        let point = marker._map.latLngToLayerPoint(popup.getLatLng())
        let rectMap = marker._map._container.getBoundingClientRect()
        let rectPopup = popup._container.getBoundingClientRect()
        let needChangeMapCenter = false
        // top margin
        if (rectPopup.top < rectMap.top) {
          // point.y = point.y + size
          needChangeMapCenter = true
        }
        // left margin
        if (rectPopup.left < rectMap.left) {
          // point.x = point.x + size
          needChangeMapCenter = true
        }
        /* console.log('rectMap', rectMap)
        console.log('rectPopup', rectPopup)
        console.log('Point', point)
        console.log('Map', marker._map) */
        if (needChangeMapCenter === true) {
          let latlng = marker._map.layerPointToLatLng(point)
          marker._map.setView(latlng)
        }
      } else {
        console.error('data for punPopup not found', marker, popup)
      }
    }, 0)
  }
}

export default BaseDrawer
